import RestResource from "~/modules/rest/RestResource";

class ChatResource extends RestResource {
  protected static basePath = "/chat";

  static getHomeUrl = () => {
    return this.fetch(`${this.ApiRead}/home`, { method: "POST" });
  }

  static getToken(roomId: string | number) {
    return this.fetch(
      `${this.ApiRead}/get_token`,
      { 
        method: "POST", 
        body: {
          "room_id" : roomId
        } 
      }
    );
  }
}

class CommentResource extends RestResource {
  static basePath = "/comments";

  static getComments(postId: string | number) {
    return this.fetch(`${this.ApiRead}/${postId}`, { method: "GET" });
  }

  static getReplies(postId: number, commentId: number) {
    return this.fetch(`${this.ApiRead}/${postId}/reply/${commentId}`, { method: "GET" });
  }

  static getCommentsByPaginatorLink(link: string) {
    return this.fetch(link, { method: "GET" });
  }

  static sendComment(postId: string | number, comment: string, commentId: number | null = null) {
    return this.fetch(`${this.ApiWrite}/store`, {
      method: "POST",
      body: {
        post_id: postId,
        message: comment,
        comment_id: commentId,
      },
    });
  }

  static deleteComment(commentId: string | number) {
    return this.fetch(`${this.ApiWrite}/${commentId}`, { method: "DELETE" });
  }

}

class ModelResource extends RestResource {
  protected static basePath = "/models";
  static INDEX = true;
  static GET = true;

  static getPost = ({
    modelID,
    postID,
  }: {
    modelID: string | number;
    postID: string;
  }) =>
    this.fetch(`${this.ApiRead}/${modelID}/posts/${postID}`, { method: "GET" });
}

class PostResource extends RestResource {
  protected static basePath = "/posts";
  static INDEX = true;
  static GET = true;
}

class UserLastLangResource extends RestResource {
  protected static basePath = "/user_last_lang";
  static POST = true;
}

class ChatModelResource extends RestResource {
  protected static basePath = "/chat/model";

  static storeAt(params: { id: number | string }) {
    return this.fetch(`${this.ApiWrite}/${params.id}`, {
      method: "POST",
      body: params,
    });
  }
}

class TokensResource extends RestResource {
  protected static basePath = "/tokens";
  static INDEX = true;
  static POST = true;

  static balance() {
    return this.fetch(`${this.ApiRead}/balance`, { method: "GET" });
  }
}

class MoviesResource extends RestResource {
  protected static basePath = "/movies";
  static INDEX = true;
  static GET = true;
}

class VideosResource extends RestResource {
  protected static basePath = "/videos";
  static INDEX = true;
  static GET = true;
}

class PostLikeResource extends RestResource {
  static basePath = "/post_likes";

  static toggleLike({ postID }: { postID: string | number }) {
    return this.fetch(this.ApiWrite, {
      method: "POST",
      params: { post_id: postID },
    });
  }
}

class PostOptionResource extends RestResource {
  static basePath = "/post_options";

  static report(body: {
    postId: string | number;
    modelId: string;
    reason: string;
    userEmail: string;
  }) {
    return this.fetch(`${this.ApiWrite}/report`, { method: "POST", body });
  }
}

class WebstarsResource extends RestResource {
  static basePath = "";

  static get ApiWrite() {
    return useRuntimeConfig().public.VUE_APP_WEBSTARS_PANEL_URL;
  }

  static LoginURL({ model_id, token }: { model_id: string; token: string }) {
    return `${this.ApiWrite}/fetch-token-login?model_id=${model_id}&token=${token}`;
  }

  static LoginURLWithRedirect({ model_id, token }: { model_id: string; token: string }) {
    return `${this.ApiWrite}/login?model_id=${model_id}&token=${token}`;
  }

  static LogoutURL() {
    return `${this.ApiWrite}/logout`;
  }

  static RegisterUrl() {
    return `${this.ApiWrite}/register`;
  }

  static HomeUrl() {
    return `${this.ApiWrite}`;
  }
}
class UserResource extends RestResource {
  static basePath = "/user";

  static changeProfilePicture({ file }: { file: File }) {
    const formData = new FormData();
    formData.append("profile_pic", file);
    
    return this.fetch(
      `${this.ApiWrite}/profile_pic`, 
      {
        method: "POST",
        body: formData
      }
    );
  }

  /*
  * Get the profile picture URL from the raw path.
  * This is not a REST API call.
  */
  static getProfilePicURL(rawPath: string) {
    return `${this.ApiRead}/${rawPath}`;
  }
}  

export default {
  /* Resources */
  chat: ChatResource,
  chatModel: ChatModelResource,
  comments: CommentResource,
  userLastLang: UserLastLangResource,

  posts: PostResource,
  postLike: PostLikeResource,
  postOption: PostOptionResource,

  models: ModelResource,

  tokens: TokensResource,

  movies: MoviesResource,
  videos: VideosResource,

  webstars: WebstarsResource,
  user: UserResource
  /* Resources */
};
